{
  "conversation": {
    "agent_mode": {
      "saved": "Profil enregistré",
      "agents": {
        "kaila": {
          "name": "Jura",
          "description": "Assistant juridique"
        },
        "kfc": {
          "name": "Agent de traitement",
          "description": "Cette conversation est basée sur le profil de l'agent de traitement. Les documents téléchargés par la commune sont utilisés dans les réponses."
        },
        "replay": {
          "name": "Relecture",
          "description": "Relire les conversations précédentes"
        },
        "mock": {
          "name": "Simulate",
          "description": "Agent simulé"
        }
      }
    },
    "ask_kaila_back": {
      "submit_button": "Répondre",
      "user_selected": "J’ai choisi les options suivantes :",
      "mode_question": "Question",
      "mode_suggestion": "Suggestion",
      "switch_mode": "Faites des recherches approfondies",
      "keep_previous_mode": "Gardez la réponse {{previous}}",
      "about_deep": "Une recherche approfondie peut vous donner une réponse plus complète",
      "deep_description": "Une recherche approfondie vérifie la législation, la jurisprudence et les sources associées avant de répondre, afin d’obtenir plus de contexte et de références.",
      "kfc_title": "Sur quels domaines devrais-je me concentrer ?",
      "kfc_description": "J'ai identifié les domaines suivants comme étant potentiellement pertinents pour votre question. Sélectionnez toutes les options qui s'appliquent.",
      "skip": "Passer"
    },
    "references_panel": {
      "empty_state": "Aucune source pour cette réponse.",
      "source_validation": {
        "button": "Afficher le",
        "toggle_type": "type",
        "toggle_name": "titre"
      },
      "error": {
        "title": "Une erreur s'est produite",
        "description": "Une erreur s’est produite lors du chargement des sources"
      },
      "go_to_document": "Aller au document",
      "header": "Sources",
      "no_content_disclaimer": "Aucun aperçu disponible",
      "open_in_karnov": "Ouvrir dans Lamy Liaisons",
      "ai_generated_summary": {
        "text": "Résumé par LamyLia",
        "tooltip": "La jurisprudence est résumée par l’IA pour donner un aperçu rapide."
      }
    },
    "annotation_type": {
      "karnov": "Notes de Lamy Liaisons",
      "lexino": "",
      "nj_annotation": ""
    },
    "conversation_error": {
      "title": "Une erreur s'est produite",
      "description": "Une erreur s'est produite avec la conversation. Essayez de recharger la page ou contactez le service client.",
      "guide": "Aidez-nous à résoudre le problème en partageant le contenu de la conversation.",
      "send_to_support": "Partager la conversation avec nous",
      "success_title": "Rapport d'erreur envoyé",
      "success_message": "Merci, votre rapport d'erreur a été envoyé"
    },
    "conversation_feedback": {
      "cancel": "Passer l'étape",
      "confirmation": "Merci de partager votre avis.",
      "conversation_rating_question": "Justifiez votre évaluation ",
      "description": "Sélectionnez la catégorie la plus adaptée à votre remarque. Des avis détaillés nous permettent d’améliorer les réponses de LamyLia. En envoyant votre retour, vous acceptez que nous consultions votre avis, la conversation complète, les sources et les fichiers joints.",
      "error": "Un problème est survenu, veuillez réessayer",
      "feedback_modal": "Nous aimerions recevoir votre avis",
      "consent_checkbox": "J’accepte d’être contacté(e) si des informations complémentaires sont nécessaires.",
      "options": {
        "1": {
          "title": "Hallucinations (faits faux, références inventées, etc.)",
          "placeholder": "La réponse contient des références inventées ou des conclusions qui ne sont pas appuyées par des sources juridiques valides."
        },
        "2": {
          "title": "Problème de pertinence de la réponse, y compris sur le plan juridique",
          "placeholder": "La réponse s’appuie sur des sources juridiques abrogées ou ne comporte pas de références à des sources juridiques pertinentes. Indiquez la/les source(s) manquante(s)."
        },
        "3": {
          "title": "Réponse pas suffisamment claire ou précise",
          "placeholder": "La réponse est ambiguë ou ne comporte pas les précisions nécessaires."
        },
        "4": {
          "title": "Problème d’utilisation ou d’interprétation du contexte (également pour les suggestions/réponses aux questions de suivi)",
          "placeholder": "Mauvaise interprétation de la question posée ou du contexte fourni."
        },
        "5": {
          "title": "Problème lié aux sources/citations (obsolètes, mal interprétées, etc.)",
          "placeholder": "La réponse n’inclut pas les sources juridiques les plus récentes ou repose sur une mauvaise interprétation des sources citées."
        },
        "6": {
          "title": "Autre",
          "placeholder": "Avez-vous rencontré d’autres problèmes avec la réponse ? Dites-le nous"
        }
      },
      "submit": "Envoyer le commentaire",
      "textarea_placeholder": "N’hésitez pas à détailler…",
      "title": "Merci de partager votre avis."
    },
    "conversation_sources": "Références",
    "prompt_templates": {
      "create_title": "Enregistrer un nouveau prompt",
      "create_description": "Enregistrez des prompts pour les réutiliser plus tard, notamment pour les tâches et questions récurrentes.",
      "edit_title": "Modifier le prompt",
      "title_label": "Titre",
      "title_placeholder": "",
      "content_label": "Votre prompt",
      "content_placeholder": "",
      "save": "Enregistrer",
      "cancel": "Annuler",
      "delete": "Supprimer",
      "save_success": "Prompt enregistré",
      "save_error": "Impossible d'enregistrer le prompt",
      "validation_error": "Vérifiez le titre et le prompt, puis réessayez",
      "delete_success": "Prompt supprimé",
      "delete_error": "Impossible de supprimer le prompt",
      "delete_confirm": {
        "title": "Supprimer le prompt",
        "question": "Êtes-vous sûr de vouloir supprimer ce prompt ?",
        "confirm": "Supprimer",
        "cancel": "Annuler"
      },
      "title": "Prompts enregistrés",
      "description": "Si vous posez souvent les mêmes questions ou réutilisez régulièrement le même contexte, enregistrez vos prompts ici pour les réutiliser en un seul clic, quand vous en avez besoin.",
      "new_prompt": "Nouveau prompt",
      "search_placeholder": "Rechercher des prompts...",
      "search_aria": "Rechercher parmi les prompts enregistrés",
      "search_clear": "Effacer la recherche",
      "see_details": "Voir les détails",
      "close_details": "Masquer les détails",
      "edit": "Modifier",
      "edit_prompt_aria": "Modifier le prompt : {{title}}",
      "trigger_label": "Prompts",
      "trigger_tooltip": "Ouvrir les prompts enregistrés",
      "no_results": "Aucun résultat",
      "close": "Fermer les prompts enregistrés",
      "delete_prompt_aria": "Supprimer le prompt : {{title}}",
      "error": {
        "title": "Une erreur s'est produite",
        "description": "Une erreur s'est produite lors du chargement des prompts enregistrés"
      },
      "pagination": "Pagination",
      "pagination_previous": "Précédent",
      "pagination_next": "Suivant",
      "pagination_previous_aria": "Aller à la page précédente",
      "pagination_next_aria": "Aller à la page suivante",
      "pagination_page_aria": "Aller à la page {{page}}",
      "attachment_warning": "Les fichiers importés et les références ne sont pas encore pris en charge pour les prompts enregistrés.",
      "suggest": "Suggérer",
      "generating_title": "Génération du titre",
      "title_error": "Impossible de générer un titre."
    },
    "message_done_toast": "Votre conversation est terminée. Cliquez ici pour accéder à la conversation",
    "message_done_toast_with_subject": "Votre conversation \"{{subject}}\" est terminée. Cliquez ici pour accéder à la conversation",
    "error": {
      "no_access": {
        "description": "Sélectionnez une autre conversation ou commencez-en une nouvelle dans le menu",
        "title": "Vous n’avez pas accès à cette conversation"
      },
      "not_found": {
        "description": "Sélectionnez une autre conversation ou commencez-en une nouvelle dans le menu",
        "title": "Conversation introuvable"
      },
      "unknown": {
        "description": "Essayez de recharger la page",
        "title": "Votre conversation ne peut pas être récupérée pour le moment"
      }
    },
    "message_action": {
      "cancel_edit_message": "Annuler la modification",
      "copy_message": "Copier",
      "delete_failed_user_message": "Supprimer",
      "downvote_message": "Je n'aime pas",
      "upvote_message": "J'aime",
      "edit_message": "Modifier la question",
      "edit": "Modifier",
      "export_docx": "Exporter vers Word",
      "export": "Exporter",
      "more_actions": "Plus d'actions",
      "print_message": "Imprimer",
      "regenerate_message": "Régénérer la réponse",
      "save_message": "Enregistrer ce prompt",
      "save": "Enregistrer",
      "skip_to_content": "Retourner au début du message",
      "to_top": "Début du message"
    },
    "export_docx": {
      "success": "Document exporté avec succès",
      "error": "Impossible d'exporter le document",
      "question_heading": "Question",
      "answer_heading": "Réponse"
    },
    "prompt_input": {
      "disclaimer_text": "LamyLia facilite votre recherche, sans se substituer à votre expertise juridique.",
      "disclaimer_link": {
        "prefix": "",
        "text": "",
        "suffix": "",
        "href": ""
      },
      "placeholder": "Poser une question",
      "placeholder_follow_up": "Poursuivre la conversation",
      "document_tag": "Rechercher un document"
    },
    "document_tagging": {
      "placeholder": "Saisir le nom du document",
      "prompt_input_suggestion": "Référencer un document",
      "clear_input": "Effacer la recherche",
      "finding_documents": "Récupération des documents…",
      "search_for_documents_title": "Recherchez un document Lamy Liaisons",
      "search_for_documents_description": "Veuillez indiquer le titre ou la référence du document",
      "no_documents_found_title": "Aucun document trouvé",
      "no_documents_found_description": "Saisissez un titre ou une référence valide, ou allez sur Lamy Liaisons Online pour trouver le document.",
      "kfc_disclaimer": "LamyLia a déjà accès à vos documents locaux, il n’est donc pas nécessaire de les étiqueter.",
      "error_title": "Un problème est survenu",
      "error_description": "Essayez de recharger la page",
      "title": "Résultat de recherche"
    },
    "prompt_button": {
      "label": "Demander à LamyLia",
      "stop": "Annuler"
    },
    "research_mode": {
      "light": {
        "name": "Recherche rapide",
        "short": "Rapide",
        "description": "Pour les questions simples. Interroge une sélection limitée de sources ; ne constitue pas une recherche exhaustive."
      },
      "regular": {
        "name": "Recherche standard",
        "short": "Standard",
        "description": "Parcourt l'intégralité des sources Karnov et élabore une réponse structurée."
      },
      "deep": {
        "name": "Recherche approfondie",
        "short": "Approfondie",
        "description": "Effectue une recherche exhaustive pour les questions complexes. Nécessite plus de temps."
      }
    },
    "user_message": {
      "cancel_button": "Annuler",
      "submit_button": "Enregistrer et envoyer"
    },
    "table_view": {
      "close_button": "Fermer l’affichage plein écran du tableau",
      "modal_title": "Tableau en plein écran",
      "open_button": "Ouvrir en plein écran"
    },
    "loading_header": {
      "estimated_time": "Temps estimé d’attente",
      "less_than_a_minute": "Moins d’une minute",
      "minutes_one": "{{count}} minute",
      "minutes_other": "{{count}} minutes",
      "slow_answer_disclaimer": "Génération d’une réponse complexe. Cela peut prendre un peu plus de temps."
    },
    "clipboard": {
      "copy_success": "Contenu copié",
      "copy_error": "Échec de la copie du contenu"
    }
  },
  "conversation_history": {
    "load_more_button": "Charger plus",
    "load_more_title": "Affichage de la page {{currentPage}} sur {{totalPages}}",
    "no_more_conversations": "Vous avez atteint la fin de votre historique de conversations.",
    "go_to_top": "Aller en haut de la liste",
    "close_conversation_history_panel": "Masquer l’historique",
    "close_conversation_sidepanel": "Fermer le panneau latéral",
    "conversation_expiration_one": "{{count}} jour",
    "conversation_expiration_other": "{{count}} jours",
    "conversation_expiration_tooltip_one": "Sera supprimée dans 1 jour, sauf si vous interagissez pour la maintenir active.",
    "conversation_expiration_tooltip_other": "Sera supprimée dans {{count}} jours, sauf si vous interagissez pour la maintenir active.",
    "conversation_expiration_expired_tooltip": "Vos conversations sont conservées pendant 90 jours après la dernière activité. Elles sont ensuite supprimées automatiquement.",
    "conversation_action": {
      "delete": "Supprimer",
      "pin": "Epingler",
      "rename": "Renommer",
      "unpin": "Désépingler"
    },
    "conversation_delete_modal": {
      "cancel_button": "Annuler",
      "delete_button": "Supprimer",
      "title": "Supprimer la conversation",
      "question": "Êtes-vous sûr de vouloir supprimer la conversation"
    },
    "error": {
      "description": "Essayez de recharger la page",
      "title": "Votre historique ne peut pas être récupéré pour le moment"
    },
    "expired_conversations_onboarding": "Pour protéger vos données, les conversations inactives depuis plus de 90 jours seront désormais définitivement supprimées.",
    "history": "Historique",
    "history_expiration_time": "90 jours",
    "history_short": "Historique",
    "history_tooltip": "Vos conversations sont conservées pendant 90 jours après la dernière activité. Elles sont ensuite supprimées automatiquement.",
    "new_conversation_button": "Nouvelle conversation",
    "new_conversation_button_short": "Nouveau",
    "new_conversation_subject": "Nouvelle conversation",
    "new_document_analysis_button": "Analyse de document",
    "new_document_analysis_button_beta_label": "BETA",
    "new_document_analysis_button_new_label": "Nouveau",
    "new_document_analysis_button_short": "Analyse",
    "flow_access_link": "LamyLia Connect",
    "flow_access_link_short": "Connect",
    "open_conversation_history_panel": "Afficher l’historique",
    "open_conversation_sidepanel": "Ouvrir le panneau latéral",
    "panel_header": "Menu",
    "pinned": "Epinglé",
    "edit_conversation_subject_submit": "Enregistrer les modifications du sujet de la conversation",
    "edit_conversation_subject_cancel": "Annuler les modifications du sujet de la conversation",
    "search_in_conversation": "Rechercher dans les conversations",
    "search_in_conversation_description": "Rechercher dans les conversations par sujet",
    "search_in_conversation_clear": "Effacer la recherche",
    "empty_search_in_conversation": "Aucune conversation trouvée avec la recherche: \"{{searchTerm}}\"",
    "toast_notification": {
      "conversation_pinned_error": "Échec de l’épinglage de la conversation",
      "conversation_unpinned_error": "Échec du désépinglage de la conversation",
      "conversation_pinned_successful": "Conversation épinglée",
      "conversation_unpinned_successful": "Conversation désépinglée",
      "conversation_delete_success": "Conversation supprimée",
      "conversation_delete_error": "La conversation n’a pas été supprimée",
      "subject_editting_error": "Les modifications n’ont pas pu être effectuées",
      "subject_editting_sucessful": "Modifications effectuées"
    },
    "today": "Aujourd’hui",
    "yesterday": "Hier",
    "latest_7_days": "Les 7 derniers jours",
    "latest_15_days": "Les 15 derniers jours",
    "latest_30_days": "Les 30 derniers jours",
    "latest_60_days": "Les 60 derniers jours",
    "more_than_60_days": "Plus de 60 jours - Expiration proche",
    "expired": "Expire bientôt",
    "retention_info": "Vos conversations actives sont conservées pendant 90 jours. Passé ce délai, elles sont automatiquement supprimées pour vous aider à protéger votre vie privée."
  },
  "file_upload": {
    "capacity_usage": "{{space}} % d'espace utilisé",
    "content_type": {
      "application/pdf": "PDF",
      "application/msword": "Word",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "Word",
      "unknown": "Inconnu",
      "unsupported": "Type de fichier non pris en charge"
    },
    "drag_and_drop_label_one": "Importez jusqu’à {{limit}} document",
    "drag_and_drop_label_other": "Importez jusqu’à {{limit}} documents",
    "file_upload_limit_exceeded": "Vous avez sélectionné trop de fichiers.",
    "file_upload_limit_reached": "Vous ne pouvez pas télécharger d'autres documents.",
    "header": "Téléchargez votre document pour lancer l’analyse",
    "subheader": "Format Word (.docx) ou PDF. Taille maximale : 20 Mo",
    "upload_button": "Charger un document",
    "upload_status": {
      "error": "Erreur",
      "uploading": "Importation en cours",
      "deleting": "Suppression"
    },
    "error": {
      "above_page_count_limit": "Les fichiers ne doivent pas contenir plus de 400 pages.",
      "above_word_count_limit": "Les fichiers ne doivent pas contenir plus de 100 000 mots",
      "above_file_size_limit": "Les fichiers ne doivent pas dépasser 20 Mo.",
      "content_too_large": "Les fichiers ne doivent pas dépasser 20 Mo.",
      "malformed_file_content": "Le fichier n'a pas pu être lu - il est peut-être endommagé",
      "deletion_error": "Une erreur est survenue lors de la suppression du fichier.",
      "invalid_mime_type": "Ce type de fichier n'est pas pris en charge. Vous pouvez uniquement importer des fichiers Word (.docx) et PDF.",
      "exceeds_token_limit": "Ce document dépasse la limite d'espace et ne sera pas utilisé.",
      "upload_error": "Une erreur est survenue lors du téléversement.",
      "virus_detected": "Le fichier téléchargé semble contenir un virus."
    }
  },
  "frequently_asked_questions": {
    "footer": {
      "customer_service": "Contactez-nous",
      "customer_service_url": "https://boutique.lamy-liaisons.fr/contacts.html",
      "terms": "Conditions d’utilisation",
      "terms_url": "https://www.lamy-liaisons.fr/conditions-generales-utilisation/"
    },
    "help": "Aide",
    "helpful_question_answer_title": "Cela a-t-il répondu à votre question ?",
    "helpful_question_answer_button_yes": "Oui",
    "helpful_question_answer_button_no": "Non",
    "thank_you_for_feedback_description": "Votre contribution nous aide à améliorer ces informations pour tous.",
    "thank_you_for_feedback_title": "Merci pour votre retour !",
    "thank_you_for_feedback_toast_notification": "Merci pour votre retour",
    "related_questions": "Questions connexes"
  },
  "help_and_feedback": {
    "button": "Aide et retour",
    "dropdown_options": {
      "help": "Aide",
      "tutorial": "On vous guide",
      "user_carousel_onboarding": "Onboarding"
    }
  },
  "kfc": {
    "description": "La première réponse est basée sur des sources de la base de données de Lamy Liaisons, tandis que cette réponse complémentaire s’appuie sur les documents internes de votre commune, à condition qu’ils aient été téléversés et soient disponibles dans Lamy Liaisons. Les deux réponses incluent des références et des liens vers les sources sur lesquelles elles s’appuient."
  },
  "message": {
    "create_conversation_message_error": "Envoi impossible.",
    "create_conversation_message_retry": "Réessayer",
    "streaming_waiting": "En attente de réponse",
    "streaming_canceled": "Réponse arrêtée",
    "streaming_error": "Une erreur est survenue lors de la génération de la réponse",
    "streaming_error_retry": "Régénérer",
    "streaming_error_code": "Code d'erreur",
    "streaming_error_conversation": "Conversation",
    "streaming_reconnect_error": "Une erreur est survenue lors de la tentative de reconnexion",
    "streaming_reconnect_error_retry": "Essayez de rétablir la connexion",
    "thoughts": "Réflexions en cours",
    "follow_up": "Vous pouvez aussi demander",
    "follow_up_description": "Les suggestions de questions de suivi vous aident à poursuivre la conversation. Vous pouvez en choisir une et l’adapter à votre situation en donnant plus de contexte, en orientant ou en élargissant la discussion.",
    "updated_at": "{{updatedAt, date}}"
  },
  "no_access": {
    "title": "Vous n’avez pas accès à ce contenu",
    "description": "Ce contenu nécessite l'accès à un produit ou un abonnement spécifique, qui n'est pas compris dans votre périmètre actuel.",
    "refresh_access": {
      "button": "Actualiser l'accès",
      "description": "Si vous pensez qu’il s’agit d’une erreur, veuillez actualiser vos paramètres d’accès. Cette opération devrait mettre à jour votre abonnement et débloquer l’ensemble des contenus auxquels vous avez accès.",
      "contact_support": "Si le problème persiste, veuillez contacter notre service client aux coordonnées indiquées ci-dessous. Notre équipe se fera un plaisir de vous aider."
    },
    "contact_info": {
      "header": "Nous sommes là pour vous aider",
      "description": "Appelez ou écrivez à notre service client pour en savoir plus sur les différentes licences",
      "link": {
        "prefix": "",
        "text": "",
        "suffix": "",
        "href": ""
      },
      "phone": "09 69 39 58 58",
      "email": ""
    }
  },
  "system_messages": {
    "_ANALYSING_DOCUMENTS_": "Analyse des documents",
    "_ANALYSING_QUERY_": "Analyse de la question",
    "_ANALYSING_SOURCES_": "Analyse des sources",
    "_FETCHING_SIMILAR_DOCUMENTS_": "Recherche de sources",
    "_FETCHING_LAW_DOCUMENTS_": "Recherche de références légales",
    "_FETCHING_PREPATORY_WORK_DOCUMENTS_": "Recherche des travaux préparatoires",
    "_FETCHING_LITERATURE_DOCUMENTS_": "Recherche de références bibliographiques",
    "_GENERATING_ANSWER_": "Génération d’une réponse"
  },
  "document_tag_tooltip": "Cliquer ou saisir @ pour faire référence à un document",
  "input_character_limit_reached": "Nombre maximal de caractères atteint",
  "user_carousels": {
    "dismiss": "Continuer",
    "carousels": {
      "onboarding": {
        "title": "Bienvenue sur LamyLia",
        "read_more_url": "",
        "screens": {
          "welcome": {
            "description": "L’IA de Lamy Liaisons vous permet de poser vos questions en langage courant et d’accéder rapidement à l’information juridique pertinente",
            "header": "Trouvez des réponses à vos questions juridiques"
          },
          "credibility": {
            "description": "LamyLia s’appuie sur les contenus de Lamy Liaisons pour proposer des réponses claires, fiables et régulièrement mises à jour",
            "header": "Fondé sur le contenu de Lamy Liaisons"
          },
          "security": {
            "description": "LamyLia traite vos données dans un environnement sécurisé et conforme à la réglementation en vigueur.",
            "header": "Vos données sont protégées"
          },
          "feedback": {
            "description": "Évaluez les réponses et signalez ce qui doit être complété ou précisé : vos retours sont importants et nous permettent de nous améliorer pour répondre à vos besoins",
            "header": "Aidez‑nous à améliorer LamyLia"
          }
        }
      }
    },
    "read_more_label": "En savoir plus"
  },
  "header": {
    "goto_main_content": "Aller au contenu principal"
  },
  "user_menu": {
    "logout": "Se déconnecter",
    "go_to_platform": "Lamy Liaisons",
    "redirect_to_login": "Mettre à jour l’accès",
    "theme_selector": {
      "appearance": "Affichage",
      "theme": {
        "dark": "Sombre",
        "light": "Clair",
        "system": "Classique"
      }
    },
    "language_selector": {
      "content": "contenu",
      "header": "Langue",
      "languages": {
        "da": "Danois",
        "es": "Espagnol",
        "fr": "Français",
        "sv": "Suédois",
        "no": "Bokmål (norvégien)",
        "nn": "Nynorsk (norvégien)"
      }
    },
    "go_to_flow": "LamyLia Connect",
    "learn_about_flow": "LamyLia connect - En savoir plus",
    "badge": "Nouveau"
  },
  "platform_name": "LamyLia",
  "document_analysis": {
    "select_document_analysis_mode": "Choisissez une analyse",
    "hero_banner": {
      "intro": "Lamy Liaisons vous présente",
      "headline": "Analyse de document",
      "description": "Grâce à des analyses exclusives élaborées par nos experts, transformez la complexité du droit en solutions concrètes."
    },
    "file_upload_header": {
      "description": "Téléversez votre contrat pour commencer",
      "title": "Examen de contrat"
    },
    "use_prompt_button": "Sélectionnez cette analyse",
    "see_example_button": "Voir un exemple",
    "back_to_document_analysis_list": "Retour aux analyses de documents",
    "options": {
      "contract_review": {
        "title": "Analysez des contrats",
        "description": "Analyse clause par clause, identification des principaux risques et déséquilibres, propositions de rédaction ou de renégociation, avec fondements juridiques expliqués de façon structurée. Pour les contrats de services, contrats de licence, contrats de distribution, conditions générales ou encore contrats de travail.",
        "guide": "En plus du document téléchargé, vous pouvez ajouter des informations complémentaires, comme le type de contrat et les parties, ainsi que d’autres éléments pertinents non visibles dans le document.",
        "example_text": "Voici un exemple d’analyse. Il donne une vue d’ensemble des réponses de LamyLia afin que vous puissiez évaluer si cela correspond à vos besoins.",
        "placeholder": "Ajouter des informations complémentaires"
      },
      "document_compliance": {
        "title": "Analyse de la conformité",
        "description": "Repérage des écarts de conformité, évaluation des risques associés et recommandations hiérarchisées dans un rapport prêt à l’emploi, utile pour la direction, le contrôle interne et la conformité. Pour l’examen de politiques internes, de procédures, de codes de conduite, de documents de protection des données et de dispositifs de contrôle interne.",
        "guide": "En plus du document téléchargé, vous pouvez ajouter des informations complémentaires, comme la partie que vous représentez, ou toute autre circonstance pertinente qui n’est pas exposée dans le document.",
        "example_text": "",
        "placeholder": "Ajouter des informations complémentaires"
      },
      "argument_strengthener": {
        "title": "Analyse de vos arguments",
        "description": "Examen approfondi de vos argumentaires, mise en évidence des faiblesses, propositions d’amélioration (fondements juridiques, structure, formulation, réponses aux objections) pour des positions plus solides et défendables. Pour les notes internes, les avis juridiques, les écritures de litige, les réponses aux autorités ou les notes de décision.",
        "guide": "En plus du document téléchargé, vous pouvez ajouter des informations complémentaires, comme la partie que vous représentez, ou toute autre circonstance pertinente qui n’est pas exposée dans le document.",
        "example_text": "",
        "placeholder": "Ajouter des informations complémentaires"
      },
      "weakness_finder": {
        "title": "Analyse des faiblesses adverses",
        "description": "Lecture critique des arguments et sources de la partie adverse, identification des incohérences et lacunes, élaboration de contre‑arguments, d’axes d’attaque et d’éléments de langage pour renforcer votre position. Pour analyser des courriers adverses, des conclusions et mémoires, des projets de contrats reçus, des rapports de contrôle ou des argumentaires de conseils externes.",
        "guide": "En plus du document téléchargé, vous pouvez ajouter des informations complémentaires, comme la partie que vous représentez, ou toute autre circonstance pertinente qui n’est pas exposée dans le document.",
        "example_text": "",
        "placeholder": "Ajouter des informations complémentaires"
      }
    }
  },
  "workspace_promo_banner": {
    "text": "Passez à la rédaction avec LamyLia Connect",
    "link": "En savoir plus",
    "badge": "Nouveau"
  },
  "prompt_suggestions": {
    "kaila": {
      "title": "Posez votre question, obtenez la réponse juridique",
      "description": "Quelques questions pour vous aider à démarrer",
      "templates": [
        {
          "category": "book-section",
          "prompt": "J’ai besoin d’arguments pour défendre une entreprise dans un litige de rupture brutale de relation commerciale établie.",
          "sample": "J’ai besoin d’arguments pour défendre une entreprise dans un litige de rupture brutale de relation commerciale établie."
        },
        {
          "category": "scale-unbalanced-flip",
          "prompt": "Prépare un aperçu des points à vérifier dans un contrat de licence SaaS destiné à une clientèle grands comptes.",
          "sample": "Prépare un aperçu des points à vérifier dans un contrat de licence SaaS destiné à une clientèle grands comptes."
        },
        {
          "category": "scale-unbalanced-flip",
          "prompt": "Quelles solutions d’anticipation successorale pour un couple marié en communauté réduite aux acquêts, détenant des biens professionnels et un patrimoine locatif?",
          "sample": "Quelles solutions d’anticipation successorale pour un couple marié en communauté réduite aux acquêts, détenant des biens professionnels et un patrimoine locatif?"
        },
        {
          "category": "book-section",
          "prompt": "Indique les points clés pour sécuriser juridiquement un dispositif de forfait jours intégrant télétravail et flexibilité horaire.",
          "sample": "Indique les points clés pour sécuriser juridiquement un dispositif de forfait jours intégrant télétravail et flexibilité horaire."
        }
      ]
    },
    "kfc": {
      "title": "Posez votre question, obtenez la réponse juridique",
      "description": "Quelques questions pour vous aider à démarrer",
      "templates": [
        {
          "category": "book-section",
          "prompt": "Un bénéficiaire de l’aide sociale qui remplit les conditions pour des congés peut-il d’abord prendre 14 jours de congés avec allocation puis 14 jours sans allocation ?",
          "sample": "Un bénéficiaire de l’aide sociale qui remplit les conditions pour des congés peut-il d’abord prendre 14 jours de congés avec allocation puis 14 jours sans allocation ?"
        },
        {
          "category": "book-section",
          "prompt": "Les exercices d’étirement visant à maintenir des fonctions de base telles que l’habillage, la toilette, etc., relèvent-ils de la prestation prévue à l’article 83 de la loi sur les services sociaux ou de l’article 86 de la même loi ?",
          "sample": "Les exercices d’étirement visant à maintenir des fonctions de base telles que l’habillage, la toilette, etc., relèvent-ils de la prestation prévue à l’article 83 de la loi sur les services sociaux ou de l’article 86 de la même loi ?"
        },
        {
          "category": "book-section",
          "prompt": "À quels aspects la commune doit-elle prêter une attention particulière lorsqu’elle décide de la suppression d’une voie privée commune ?",
          "sample": "À quels aspects la commune doit-elle prêter une attention particulière lorsqu’elle décide de la suppression d’une voie privée commune ?"
        },
        {
          "category": "book-section",
          "prompt": "Quelles exigences relatives au traitement des données personnelles s’appliquent lors de la transmission manuelle d’informations sur des personnes par une commune à une autre autorité administrative ?",
          "sample": "Quelles exigences relatives au traitement des données personnelles s’appliquent lors de la transmission manuelle d’informations sur des personnes par une commune à une autre autorité administrative ?"
        }
      ]
    },
    "replay": {
      "title": "Posez votre question, obtenez la réponse juridique",
      "description": "Quelques questions pour vous aider à démarrer",
      "templates": [
        {
          "category": "scale-unbalanced-flip",
          "prompt": "example",
          "sample": "Example"
        },
        {
          "category": "scale-unbalanced-flip",
          "prompt": "error",
          "sample": "Error"
        }
      ]
    },
    "mock": {
      "title": "Posez votre question, obtenez la réponse juridique",
      "description": "Quelques questions pour vous aider à démarrer",
      "templates": [
        {
          "category": "scale-unbalanced-flip",
          "prompt": "test",
          "sample": "test"
        },
        {
          "category": "book-section",
          "prompt": "gfm",
          "sample": "Git flavoured markdown"
        },
        {
          "category": "scale-unbalanced-flip",
          "prompt": "invalid",
          "sample": "Invalid response"
        },
        {
          "category": "book-section",
          "prompt": "markdown",
          "sample": "markdown"
        },
        {
          "category": "siren-on",
          "prompt": "markdown-invalid",
          "sample": "Invalid & malformed markdown"
        },
        {
          "category": "siren-on",
          "prompt": "markdown-error",
          "sample": "Component that throws an uncaught exception"
        },
        {
          "category": "table",
          "prompt": "table",
          "sample": "table"
        },
        {
          "category": "scale-unbalanced-flip",
          "prompt": "details",
          "sample": "details"
        },
        {
          "category": "scale-unbalanced-flip",
          "prompt": "stressTest",
          "sample": "stress test"
        },
        {
          "category": "scale-unbalanced-flip",
          "prompt": "markdownAndInlineReferences",
          "sample": "Inline references after markdown elements"
        },
        {
          "category": "scale-unbalanced-flip",
          "prompt": "refsList",
          "sample": "Inline references in list"
        },
        {
          "category": "book-section",
          "prompt": "new-refsList",
          "sample": "New reference mdx format"
        }
      ]
    }
  },
  "errors": {
    "footer": {
      "title": "Contacter le Service Client",
      "description": "{{telephone}} du lundi au jeudi 9h à 18h, le vendredi de 9h à 17h",
      "email": "",
      "telephone": "09 69 39 58 58"
    },
    "auth": {
      "no_session": {
        "title": "Vous n'êtes pas connecté",
        "subtitle": "Pour vous connecter à LamyLia : ",
        "description": "par un portail, veuillez vous connecter à partir de celui-ci. Par code ou email, veuillez sélectionner la solution juridique associée à votre abonnement : "
      },
      "default": {
        "title": "Nous n'avons pas pu vous connecter",
        "subtitle": "",
        "description": "Une erreur s'est produite lors de la connexion. Veuillez réessayer ou contacter le service client si le problème persiste."
      }
    }
  },
  "close_service_message_banner": "Fermer le message",
  "upload_modal": {
    "attachment_limit_exceeded_warning": "Vous avez atteint la limite de {{attachmentLimit}} documents par question. Supprimez un document avant d'en importer un autre.",
    "close_modal_button_label": "Terminé",
    "description": "Vous pouvez importer jusqu'à {{attachmentLimit}} documents, selon leur taille.",
    "done_button": "Terminé",
    "file_browser": {
      "browse_files": "Parcourir",
      "description": "Formats pris en charge : .pdf et .docx",
      "header": "Cliquez ici pour importer, ou glissez-déposez vos fichiers"
    },
    "capacity_indicator": {
      "attachment_count": "{{count}}/{{limit}} Documents",
      "tooltip": "Chaque document occupe un pourcentage de votre limite de téléversement totale, basé sur le nombre de mots, et non sur la taille du fichier. Les documents longs prennent donc plus de place, ce qui signifie que vous pouvez atteindre 100 % avant d'avoir téléversé 10 fichiers.",
      "used_capacity": "espace utilisé"
    },
    "file_upload_button_tooltip": "Téléverser des fichiers",
    "header": "Importer des fichiers",
    "open_modal_button": "Téléverser des fichiers",
    "onboarding_tooltip": "Nouveau : importez désormais jusqu’à 10 documents par message.",
    "reinsurance_label": "Vos documents sont protégés",
    "reinsurance_tooltip": "Karnov Group protège la confidentialité de toutes les données clients, y compris les saisies des utilisateurs, les données générées et les documents, grâce à un chiffrement robuste et conforme aux normes applicables."
  },
  "prompt_input_with_document_references": {
    "add_document_references_button": {
      "label": "Référencer des documents",
      "tooltip": "Cliquez pour référencer un document",
      "onboarding_tooltip": "Nous avons simplifié la référence aux documents."
    }
  },
  "document_references_modal": {
    "description": "En référencant des documents, vous pouvez obtenir une réponse plus précise",
    "close_modal_button_label": "Terminer",
    "document_references_count": "Références sélectionnées ({{count}})",
    "done_button": "Terminer",
    "empty_state": {
      "header": "Inclure une source dans la réponse",
      "description": "Vous pouvez utiliser cette fonctionnalité si vous voulez vous assurer qu’une ou plusieurs sources sont incluses dans la réponse de LamyLia."
    },
    "header": "Référencer des documents",
    "remove_document_reference_button": "Supprimer la référence",
    "search": {
      "fetching_suggestions": "Récupération des documents...",
      "input_label": "Rechercher un document",
      "input_placeholder": "Saisissez le nom du document ici",
      "error": {
        "description": "Essayez de recharger la page",
        "title": "Un problème est survenu"
      },
      "empty_search": {
        "description": "Saisissez un titre ou une référence valide, ou allez sur Lamy Liaisons Online pour trouver le document.",
        "kfc_disclaimer": "LamyLia a déjà accès à vos documents locaux, il n’est donc pas nécessaire de les étiqueter.",
        "title": "Aucun document trouvé"
      }
    }
  },
  "message_resources": {
    "remove_message_resource": {
      "attachment": "Supprimer le document",
      "document_reference": "Supprimer la référence"
    },
    "open_modal": {
      "attachment": "Voir les documents",
      "document_reference": "Voir les références"
    },
    "placeholder": {
      "label": {
        "attachment": "{{count}} fichiers importés",
        "document_reference": "{{count}} documents référencés"
      },
      "tooltip": {
        "attachment": "Voir tous les fichiers importés",
        "document_reference": "Voir tous les documents référencés"
      }
    }
  },
  "search": {
    "clear_input": "Effacer le texte de recherche",
    "placeholder": "Recherche..."
  }
}
